import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { HoldingsModule } from '@ddt-web/holdings';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { FamilyFooterModule } from '../family-footer/family-footer.module';
import { FamilyLatestHoldingsSkeletonComponent } from './family-latest-holdings-skeleton/family-latest-holdings-skeleton.component';
import { FamilyLatestHoldingsComponent } from './family-latest-holdings.component';

@NgModule({
	declarations: [FamilyLatestHoldingsComponent, FamilyLatestHoldingsSkeletonComponent],
	imports: [
		CommonModule,
		AnalyticsModule,
		DataServiceModule,
		HoldingsModule,
		DisclosureModule,
		FamilyFooterModule,
		RouterModule.forChild([
			{ path: '', component: FamilyLatestHoldingsComponent }
		]),
		NgxSkeletonLoaderModule,
		CwpNgFrameworkModule
	]
})
export class FamilyLatestHoldingsModule { }
